import { useForm, Link } from '@inertiajs/react'
import { ArrowRight, Loader2, Mail } from 'lucide-react'
import { AuthLayout } from '@/components/layout/AuthLayout'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

export default function SessionsNew() {
  const { data, setData, post, processing, errors } = useForm({
    email_address: ''
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post('/session')
  }

  return (
    <AuthLayout
      title="Sign In"
      heading="Sign in to Corppy"
      description="We'll email you a one-time code to verify your identity. No password needed."
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="space-y-1.5">
          <Label htmlFor="email_address" className="text-[13px] font-medium text-foreground/70">
            Work email
          </Label>
          <div className="relative">
            <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground/40" />
            <Input
              id="email_address"
              type="email"
              placeholder="name@company.com"
              value={data.email_address}
              onChange={e => setData('email_address', e.target.value)}
              autoComplete="email"
              autoFocus
              required
              className="h-11 pl-10"
            />
          </div>
          {errors.email_address && (
            <p className="text-sm text-destructive">{errors.email_address}</p>
          )}
        </div>

        <Button type="submit" className="w-full h-11 text-sm font-semibold gap-2" disabled={processing}>
          {processing ? (
            <>
              <Loader2 className="animate-spin h-4 w-4" />
              Sending code...
            </>
          ) : (
            <>
              Continue
              <ArrowRight className="w-4 h-4" />
            </>
          )}
        </Button>
      </form>

      <div className="mt-10 pt-6 border-t border-border/60 text-center">
        <p className="text-[13px] text-muted-foreground">
          New to Corppy?{' '}
          <Link href="/registration/new" className="text-primary font-semibold hover:underline underline-offset-2">
            Create an account
          </Link>
        </p>
      </div>
    </AuthLayout>
  )
}
